import { useAddons } from './useAddons';

/** Whether any add-on is enabled, i.e. a denied user has somewhere to land. */
export function useHasEnabledAddon() {
  const addonsQuery = useAddons({
    select: (data) => Boolean(data?.addons?.some((addon) => addon.enabled)),
  });

  return addonsQuery.data ?? false;
}
